var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrophyMasteryProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143566",
    "data-name": "Path 143566",
    d: "M21-18v-2.25a.752.752,0,0,0-.75-.75H6.75a.752.752,0,0,0-.75.75V-18H.75a.752.752,0,0,0-.75.75v2.85c0,2.827,3.2,5.869,7.481,6.684A7.872,7.872,0,0,0,12.375-3.15V.75h-3A1.875,1.875,0,0,0,7.5,2.625.376.376,0,0,0,7.875,3h11.25a.376.376,0,0,0,.375-.375A1.875,1.875,0,0,0,17.625.75h-3v-3.9a7.885,7.885,0,0,0,4.894-4.566C23.789-8.527,27-11.569,27-14.4v-2.85a.752.752,0,0,0-.75-.75ZM2.25-14.4v-1.35H6a21.64,21.64,0,0,0,.577,5.475C3.994-11.161,2.25-13.036,2.25-14.4ZM13.5-5.25c-2.484,0-5.25-3.675-5.25-10.125V-18.75h10.5v3.375C18.75-8.789,15.9-5.25,13.5-5.25ZM24.75-14.4c0,1.364-1.744,3.239-4.327,4.125A21.662,21.662,0,0,0,21-15.75h3.75Z",
    transform: "translate(0 21)",
    fill: "#484848"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophyMasteryProblem);
export default __webpack_public_path__ + "static/media/Icon-Trophy-MasteryProblem.a432c3b6929c3722422ab27e57ac6ec3.svg";
export { ForwardRef as ReactComponent };